import 'jspdf-autotable'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {useEffect} from 'react'

import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {PartysListWrapper} from './parti-list/PartiesList'
import {PartyEditModal} from './parti-list/party-add-edit/PartyAddEdit'

const PartyPage = () => {
  const intl = useIntl()
  const loginData: any = localStorage.getItem('branch')
  const currentUser = JSON.parse(loginData)
//  useEffect(() => {
//     // Set the title when the component mounts
//     const originalTitle = document.title; // Store the original title
    document.title = `PANEL - Parties`

//     // Cleanup: Revert to the original title (or a default) when unmounting
//     return () => {
//         document.title = originalTitle; // Or set a default like "My App"
//     }
// }, [currentUser.branch_name])

  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path='list-party'
            element={
              <>
                <PageTitle>{intl.formatMessage({id: 'PARTY.LIST'})}</PageTitle>
                <PartysListWrapper />
                {/* </div> */}
              </>
            }
          />
          <Route
            path='add-party'
            element={
              <>
                <PartyEditModal isPage  />
              </>
            }
          />
           <Route
            path='add-party/:id'
            element={
              <>
                <PartyEditModal isPage  />
              </>
            }
          />
        </Route>

        <Route index element={<Navigate to='/partys' />} />
      </Routes>
    </>
  )
}

export default PartyPage
